import {Rect} from '@legit-health/ui';

export default function scaleRect(rect: Rect, scale: number): Rect {
  return {
    topLeft: {
      x: rect.topLeft.x * scale,
      y: rect.topLeft.y * scale
    },
    width: rect.width * scale,
    height: rect.height * scale
  };
}
